import { useLanguage } from "@/contexts/LanguageContext";
import raddFulltrui from "@/assets/RaddFulltrui.png";
import voiceFulltrui from "@/assets/VoiceFulltrui.png";

const VoiceIllustration = () => {
  const { language } = useLanguage();

  const illustration = language === "is" ? raddFulltrui : voiceFulltrui;

  return (
    <div className="max-w-7xl mx-auto">
      <img 
        src={illustration} 
        alt={language === "is" ? "RaddFulltrúi" : "Voice Assistant"}
        className="w-full h-auto"
      />
    </div>
  );
};

export default VoiceIllustration;
